const InspectorMenuActive = (props: any) => (
    <svg
        width={24}
        height={25}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M21 21.3232L15 15.3232M7 10.3232L9 12.3232L13 8.32324M3 10.3232C3 11.2425 3.18106 12.1527 3.53284 13.002C3.88463 13.8513 4.40024 14.623 5.05025 15.273C5.70026 15.923 6.47194 16.4386 7.32122 16.7904C8.1705 17.1422 9.08075 17.3232 10 17.3232C10.9193 17.3232 11.8295 17.1422 12.6788 16.7904C13.5281 16.4386 14.2997 15.923 14.9497 15.273C15.5998 14.623 16.1154 13.8513 16.4672 13.002C16.8189 12.1527 17 11.2425 17 10.3232C17 9.40399 16.8189 8.49374 16.4672 7.64446C16.1154 6.79518 15.5998 6.0235 14.9497 5.37349C14.2997 4.72348 13.5281 4.20787 12.6788 3.85609C11.8295 3.5043 10.9193 3.32324 10 3.32324C9.08075 3.32324 8.1705 3.5043 7.32122 3.85609C6.47194 4.20787 5.70026 4.72348 5.05025 5.37349C4.40024 6.0235 3.88463 6.79518 3.53284 7.64446C3.18106 8.49374 3 9.40399 3 10.3232Z"
            stroke="#101828"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default InspectorMenuActive;
